import React, { useEffect} from 'react';
import { useLazyLoad } from './useLazyLoad'; // Import the custom hook

interface LazyLoadImageProps {
  src: string;
  alt: string;
  title: string;
  className?: string;
  width?: string;
  height?: string;

}

export const LazyLoadImage: React.FC<LazyLoadImageProps> = ({ src, alt, title ,className,width,height }) => {
  const { isIntersecting, ref } = useLazyLoad();

  return (
    <img
      ref={ref}
      src={isIntersecting ? src : undefined} // Load the image only if it's intersecting
      alt={alt}
      title={title}
      width={width}
      height={height}
      className={className}
      loading="lazy"
      style={{ opacity: isIntersecting ? 1 : 0.5 }} // Optional: add a fade-in effect
    />
  );
};

//new function to add eger loding and lazyload with placeholder function

// export function EagerLoadImages() { };

// export function EagerLoadImages() {
// }

// export function EagerLoadImages(): void {
//   if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
//     return; 
//   }

//   const observer = new IntersectionObserver((entries, obs) => {
//     entries.forEach((entry) => {
//       const img = entry.target;

//       if (entry.isIntersecting && img instanceof HTMLImageElement) {
//         const alreadyLoaded = img.getAttribute('data-loaded') === 'true';

//         if (!alreadyLoaded && img.parentNode instanceof HTMLElement) {
//           const eagerImg = img.cloneNode(true) as HTMLImageElement;
//           eagerImg.setAttribute('loading', 'eager');
//           eagerImg.setAttribute('data-loaded', 'true');

//           img.parentNode.replaceChild(eagerImg, img);
//           obs.unobserve(eagerImg);
//         }
//       }
//     });
//   }, {
//     rootMargin: '0px',
//     threshold: 0.1,
//   });

//   const lazyImages = document.querySelectorAll('img[loading="lazy"]');
//   lazyImages.forEach((img) => {
//     if (img instanceof HTMLImageElement) {
//       observer.observe(img);
//     }
//   });
// }

export function EagerLoadImages(): void {
  if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
    return; // Exit in SSR or unsupported environments
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const img = entry.target;

      if (img instanceof HTMLImageElement) {
        if (entry.isIntersecting) {
          // In viewport → make eager
          img.setAttribute('loading', 'eager');
        } else {
          // Out of viewport → revert to lazy
          img.setAttribute('loading', 'lazy');
        }
      }
    });
  }, {
    rootMargin: '0px',
    threshold: 0.1,
  });

  const lazyImages = document.querySelectorAll('img[loading="lazy"], img[loading="eager"]');
  lazyImages.forEach((img) => {
    if (img instanceof HTMLImageElement) {
      observer.observe(img);
    }
  });
}




// Function to add dimensions to images without width or height attributes
export function AddImageDimensions() {
  useEffect(() => {
    const setDimensions = (img: HTMLImageElement) => {
      // Check if the image has loaded
      if (img.complete && img.naturalWidth && img.naturalHeight) {
        // Set width and height attributes if they are missing
        if (!img.hasAttribute('width')) {
          img.setAttribute('width', img.naturalWidth.toString());
        }
        if (!img.hasAttribute('height')) {
          img.setAttribute('height', img.naturalHeight.toString());
        }
      } else {
        // Add a load event listener if the image is not yet loaded
        img.addEventListener('load', () => {
          if (!img.hasAttribute('width')) {
            img.setAttribute('width', img.naturalWidth.toString());
          }
          if (!img.hasAttribute('height')) {
            img.setAttribute('height', img.naturalHeight.toString());
          }
        });
      }
    };

    // Find all <img> elements without width and height attributes
    const imagesWithoutDimensions = document.querySelectorAll('img:not([width]), img:not([height])');

    // Set dimensions for each image
    imagesWithoutDimensions.forEach((img) => {
      setDimensions(img as HTMLImageElement);
    });
  }, []);

  return null; // This component does not render anything visually
}






/*--------------------new case----------------------*/



/*--------------------SetHighPriorityImages----------------------*/

export function SetHighPriorityImages() {
  useEffect(() => {
    // IntersectionObserver callback function
    const handleIntersection = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;

          // Set fetchpriority to "high" if the attribute doesn't already exist
          if (!img.hasAttribute('fetchpriority')) {
            img.setAttribute('fetchpriority', 'high');
          }

          // Stop observing once we set the attribute
          observer.unobserve(img);
        }
      });
    };

    // IntersectionObserver options
    const observer = new IntersectionObserver(handleIntersection, {
      root: null, // Use the viewport
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of the image is in view
    });

    // Find all images without the fetchpriority attribute
    const images = document.querySelectorAll('img:not([fetchpriority])');
    images.forEach((img) => observer.observe(img));

    // Listen for dynamically added images (in case images are lazy-loaded after initial page load)
    const handleDynamicImages = () => {
      const dynamicImages = document.querySelectorAll('img:not([fetchpriority])');
      dynamicImages.forEach((img) => observer.observe(img));
    };

    // Listen for changes in the DOM for dynamically loaded images
    const observerDom = new MutationObserver(handleDynamicImages);
    observerDom.observe(document.body, { childList: true, subtree: true });

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
      observerDom.disconnect();
    };
  }, []);

  return null; // No visual component rendered
}
/*--------------------SetHighPriorityImages----------------------*/
/*--------------------Imageloader----------------------*/
export function ImageLoader() {
  useEffect(() => {
    const images = document.querySelectorAll<HTMLImageElement>('img[data-src]');

    const onIntersection: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach((entry) => {
        const img = entry.target as HTMLImageElement;
        const dataSrc = img.getAttribute('data-src');

        if (entry.isIntersecting) {
          // Check if dataSrc is not null before setting it
          if (dataSrc) {
            img.setAttribute('src', dataSrc);
            img.setAttribute('loading', 'eager'); // Ensure it's eagerly loaded
            observer.unobserve(img); // Stop observing the image
          }
        } else {
          // If the image is not in the viewport, set it to lazy load
          img.setAttribute('loading', 'lazy');
        }
      });
    };

    const observer = new IntersectionObserver(onIntersection, {
      root: null,         // Observe within the viewport
      rootMargin: '0px',  // No margin around the root
      threshold: 0.1      // Trigger when 10% of the image is in view
    });

    images.forEach((img) => {
      observer.observe(img); // Start observing each image
    });

    return () => observer.disconnect(); // Clean up the observer on unmount
  }, []);

  return null; // No UI is needed for this component
}

/*--------------------Imageloader----------------------*/


/*--------------------Preloadviewportimages----------------------*/

export function PreloadViewportImages() {}
/*--------------------Preloadviewportimages----------------------*/


